import { Banner, Button, Card } from '@/components'
import { BannerIdEnum } from '@/enums'
import { useAuth } from '@/hooks'
import { System, Warranty } from '@/models'

type MonitoringErrorProps = {
    warranty: Warranty
}

const MonitoringError = ({ warranty }: MonitoringErrorProps) => {
    const auth = useAuth()
    const system = warranty.homeowner?.system as System

    return <Card className="flex flex-col items-start">
        {(system.status.isMissingIntegration || system.status.isSystemNotFound) &&
            system.manufacturer.isTesla &&
            <Banner
                allowedBanners={[BannerIdEnum.TESLA_ANNOUNCEMENT_B]}
                className="mb-6 lg:mb-6"
            />}

        {(system.status.category?.isUnmonitored || system.status.category?.isExcluded) &&
            <h2 className="mb-6 font-body text-gray-900 font-semibold text-sm">
                {system.status.category?.isUnmonitored && 'Unmonitored Site: No Data Available'}
                {system.status.category?.isExcluded && 'Excluded Site: No Data Available'}
            </h2>}
        <h3 className="flex gap-2 items-center">
            {system.status.iconBadge('xs')}
            <span className="font-body text-gray-900 font-semibold text-sm">{system.status.title}</span>
        </h3>
        {system.status.description && <p className="mt-2 font-body text-gray-700 text-sm mb-6">
            {system.status.description}
        </p>}

        <>{system.status.troubleshooting}</>

        {(auth.user?.role.isCertifiedProvider || auth.user?.role.isAdminOrStaff) &&
            system.status.isUnknownManufacturer &&
            <div className="flex justify-center gap-3 mt-5">
                <Button
                    href={auth.user?.role.isCertifiedProvider
                        ? '/profile/integrations#unsupported'
                        : `/companies/${warranty.homeowner?.company_id}/edit/integrations#unsupported`}
                >
                    Share Monitoring Access
                </Button>
            </div>}

        {(auth.user?.role.isCertifiedProvider || auth.user?.role.isAdminOrStaff) &&
            (
                (system.status.isMissingIntegration &&
                    (!system.manufacturer.isTesla || auth.user?.role.isAdminOrStaff)) ||
                system.status.isIntegrationUpdateRequired ||
                (system.status.isAuthError && system.manufacturer.isSolaredge)
            ) &&
            <div className="flex justify-center gap-3 mt-5">
                <Button
                    href={auth.user?.role.isCertifiedProvider
                        ? '/profile/integrations'
                        : `/companies/${warranty.homeowner?.company_id}/edit/integrations/${system.manufacturer.key}`}
                >
                    {system.manufacturer.isSolaredge
                        ? 'Update Your SolarEdge API Key'
                        : 'Update Credentials'}
                </Button>
            </div>}
    </Card>
}

export default MonitoringError
